export default "__VITE_ASSET__a22745d7__"